export interface IFMenuBase {
    key: string;
    title: string;
    icon?: string;
    component?: string;
    query?: string;
    requireAuth?: string;
    route?: string;
    /** 是否登录校验，true不进行校验（访客） */
    login?: boolean;
}

export interface IFMenu extends IFMenuBase {
    subs?: IFMenu[];
}

export const menu = {
    androidList: { key: '/sdk/android', title: 'SDK - Android', component: 'SdkVersion' },
    iosList: { key: '/sdk/ios', title: 'SDK - iOS', component: 'SdkVersion' },
    androidNetworkList: { key: '/network/android', title: '广告网络', component: 'Network' },
    iosNetworkList: { key: '/network/ios', title: '广告网络', component: 'Network' },
}

const menus: {
    menus: IFMenu[];
    others: IFMenu[] | [];
    [index: string]: any;
} = {
    menus: [
        menu.androidList,
        menu.iosList,
        // {
        //     key: "/android",
        //     title: "Android",
            // icon: "mobile",
            
            // subs: [
            //     { key: '/sdk/android', title: 'SDK - Android', component: 'SdkVersion' },
            //     { key: '/network/android', title: '广告网络 - Android', component: 'Network' },

                // { key: '/network/android', title: 'Android 广告网络', component: 'Network' },
                // { key: '/network/ios', title: 'iOS 广告网络', component: 'Network' },
            // ]
        // },
        // 菜单相关路由
        // {
        //     key: '/ios',
        //     title: 'iOS',
            // icon: 'scan',
            // subs: [
            //     { key: '/sdk/ios', title: 'SDK - iOS', component: 'SdkVersion' },
            //     { key: '/network/ios', title: '广告网络 - iOS ', component: 'Network' },
                
                // { key: '/sdk/android', title: 'Android SDK', component: 'SdkVersion' },
                // { key: '/sdk/ios', title: 'iOS SDK', component: 'SdkVersion' },
        //     ]
        // },
    ],
    others: [
        menu.androidNetworkList,
        menu.iosNetworkList,
        {
            key: "/network_editor",
            title: "",
            // icon: "mobile",
            subs: [
                { key: '/network_editor/android/copy/:id', title: 'Android 广告网络', component: 'NetworkEditor' },
                { key: '/network_editor/android/:id', title: 'Android 广告网络', component: 'NetworkEditor' },
                { key: '/network_editor/android', title: 'Android 广告网络', component: 'NetworkEditor' },
                { key: '/network_editor/ios/copy/:id', title: 'iOS 广告网络', component: 'NetworkEditor' },
                { key: '/network_editor/ios/:id', title: 'iOS 广告网络', component: 'NetworkEditor' },
                { key: '/network_editor/ios', title: 'iOS 广告网络', component: 'NetworkEditor' },
            ]
        },
        {
            key: "/sdk_editor",
            title: "",
            // icon: "mobile",
            subs: [
                { key: '/sdk_editor/android/copy/:id', title: 'Android SDK', component: 'SdkVersionEditor' },
                { key: '/sdk_editor/android/:id', title: 'Android SDK', component: 'SdkVersionEditor' },
                { key: '/sdk_editor/android', title: 'Android SDK', component: 'SdkVersionEditor' },
                { key: '/sdk_editor/ios/copy/:id', title: 'iOS SDK', component: 'SdkVersionEditor' },
                { key: '/sdk_editor/ios/:id', title: 'iOS SDK', component: 'SdkVersionEditor' },
                { key: '/sdk_editor/ios', title: 'iOS SDK', component: 'SdkVersionEditor' },
            ]
        },
        {
            key: '/login',
            title: 'Login',
            component: 'Login'
        }
    ], // 非菜单相关路由
};

export default menus;
